module.exports = __webpack_public_path__ + "static/media/detail-play-flipped.50c6e5f3.svg";